import { useWebPageForm } from "@/contexts/WebPageFormContext";
import Overview from "@/components/admin/Content/WebPages/AboutUs/Leadership/Overview";
import HeroSection from "@/components/admin/Content/WebPages/AboutUs/Leadership/HeroSection";
import FullPageSpinner from "@/components/ui/FullPageSpinner";
import SpacePolicyAdoption from "@/components/admin/Content/WebPages/AboutUs/Leadership/SpacePolicyAdoption";
import DevelopmentAndInnovation from "@/components/admin/Content/WebPages/AboutUs/Leadership/DevelopmentAndInnovation";
import BannerImage2 from "@/components/admin/Content/WebPages/AboutUs/Leadership/BannerImage2";
import BannerImage3 from "@/components/admin/Content/WebPages/AboutUs/Leadership/BannerImage3";
import AUAssemblyRole from "@/components/admin/Content/WebPages/AboutUs/Leadership/AUAssemblyRole";
import SpaceAsADriverOfAfricanUnity from "@/components/admin/Content/WebPages/AboutUs/Leadership/SpaceAsADriverOfAfricanUnity";
import ResponsibilityCard from "@/components/admin/Content/WebPages/AboutUs/Leadership/ResponsibilityCard";


const Leadership = () => {
  const { pageData, isLoading } = useWebPageForm();

  // This array is created solely because of the numbering on the cards for the responsibilities section
  const responsibilitiesData = [
    pageData?.LEADERSHIP_STRATEGIC_AND_POLITICAL_OVERSIGHT,
    pageData?.LEADERSHIP_GOVERNANCE_AND_LEADERSHIP_OF_AFSA,
    pageData?.LEADERSHIP_ADVOCACY_AND_REPRESENTATION,
    pageData?.LEADERSHIP_COORDINATION_AND_LIAISON,
    pageData?.LEADERSHIP_ADVISORY_STRUCTURE_AND_COMMITTEE_MANAGEMENT,
    pageData?.LEADERSHIP_PRIVATE_SECTOR_AND_STAKEHOLDER_ENGAGEMENT
  ];

  if (isLoading) {
    return <FullPageSpinner />
  }

  return (
    <div className="flex flex-col gap-8 lg:gap-12 p-4 md:p-8 lg:p-12 w-full mx-auto">
      <HeroSection data={pageData?.LEADERSHIP_BANNER ?? {
        sectionTag: 'LEADERSHIP_BANNER',
        contentType: 'WITH_FILE',
        title: 'Leadership Banner',
        description: 'Leadership and governance of AFSA'
      }} />

      <Overview data={pageData?.LEADERSHIP_THE_AFRICA_SPACE_COUNCIL ?? {
        sectionTag: 'LEADERSHIP_THE_AFRICA_SPACE_COUNCIL',
        contentType: 'WITHOUT_FILE',
        title: 'The Africa Space Council'
      }} />

      <Overview data={pageData?.LEADERSHIP_FUNCTIONS_AND_RESPONSIBILITIES ?? {
        sectionTag: 'LEADERSHIP_FUNCTIONS_AND_RESPONSIBILITIES',
        contentType: 'WITHOUT_FILE',
        title: 'Functions and Responsibilities'
      }} />

      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3 lg:gap-6">
        {responsibilitiesData.map((section, index) => {
          const tags = [
            'LEADERSHIP_STRATEGIC_AND_POLITICAL_OVERSIGHT',
            'LEADERSHIP_GOVERNANCE_AND_LEADERSHIP_OF_AFSA',
            'LEADERSHIP_ADVOCACY_AND_REPRESENTATION',
            'LEADERSHIP_COORDINATION_AND_LIAISON',
            'LEADERSHIP_ADVISORY_STRUCTURE_AND_COMMITTEE_MANAGEMENT',
            'LEADERSHIP_PRIVATE_SECTOR_AND_STAKEHOLDER_ENGAGEMENT'
          ];
          return (
            <ResponsibilityCard
              key={index}
              data={section ?? { sectionTag: tags[index], contentType: 'WITHOUT_FILE', title: `Responsibility ${index + 1}` }}
              index={index + 1}
            />
          )
        })}
      </div>

      <div className="grid gap-4 lg:grid-cols-[40%_1fr]">
        <div className="flex flex-col gap-4">
          <SpacePolicyAdoption data={pageData?.LEADERSHIP_AU_ASSEMBLY_STRATEGIC_LEADERSHIP_AND_SPACE_POLICY ?? {
            sectionTag: 'LEADERSHIP_AU_ASSEMBLY_STRATEGIC_LEADERSHIP_AND_SPACE_POLICY',
            contentType: 'WITHOUT_FILE',
            title: 'Strategic Leadership'
          }} />
          <DevelopmentAndInnovation data={pageData?.LEADERSHIP_SPACE_AS_A_CATALYST_FOR_AFRICA_DEVELOPMENT ?? {
            sectionTag: 'LEADERSHIP_SPACE_AS_A_CATALYST_FOR_AFRICA_DEVELOPMENT',
            contentType: 'WITHOUT_FILE',
            title: 'Driver of Development'
          }} />
        </div>
        <div>
          <BannerImage2 data={pageData?.LEADERSHIP_BANNER_2 ?? {
            sectionTag: 'LEADERSHIP_BANNER_2',
            contentType: 'WITH_FILE'
          }} />
        </div>
      </div>

      <div className="grid gap-4 lg:grid-cols-[1fr_40%]">
        <div>
          <BannerImage3 data={pageData?.LEADERSHIP_BANNER_3 ?? {
            sectionTag: 'LEADERSHIP_BANNER_3',
            contentType: 'WITH_FILE'
          }} />
        </div>
        <div className="flex flex-col gap-4">
          <AUAssemblyRole data={pageData?.LEADERSHIP_AU_ASSEMBLY_ROLE_AND_THE_INAURATION_OF_THE_AFRICA_SPACE_COUNCIL ?? {
            sectionTag: 'LEADERSHIP_AU_ASSEMBLY_ROLE_AND_THE_INAURATION_OF_THE_AFRICA_SPACE_COUNCIL',
            contentType: 'WITHOUT_FILE',
            title: 'AU Assembly Role'
          }} />
          <SpaceAsADriverOfAfricanUnity data={pageData?.LEADERSHIP_SPACE_AS_A_DRIVER_OF_AFRICA_DEVELOPMENT_AND_UNITY ?? {
            sectionTag: 'LEADERSHIP_SPACE_AS_A_DRIVER_OF_AFRICA_DEVELOPMENT_AND_UNITY',
            contentType: 'WITHOUT_FILE',
            title: 'Space for Unity'
          }} />
        </div>
      </div>
    </div>
  )
}

export default Leadership